import type { SVGProps } from 'react';

export const ArenaEssenceBg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 89 117"
    fill="none"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.2191 11.604L44.3767 0L41.1418 9.9201L29.7935 6.24608L25.599 19.1089L28.6428 20.0943L7.17306 85.9334L4.19448 84.9691L0 97.8319L59.2065 117L63.401 104.137L59.9726 103.027L81.4424 37.1881L84.8055 38.2769L89 25.4141L76.9843 21.5241L80.2191 11.604ZM65.1972 45.2233L37.0454 36.1092L24.0254 76.0366L55.1491 76.0366L65.1972 45.2233Z"
      fill="currentColor"
    />
  </svg>
);
